export const ENDPOINTS = {
  GET_HISTORICAL_SUMMARY: '/HistoricalData',
  // Confirmed against the live backend's swagger.json: GET/POST at /SourceInfo,
  // PUT at /SourceInfo/{id} (id is an integer — not Code).
  GET_SOURCE_INFO: '/SourceInfo',
  CREATE_SOURCE_INFO: '/SourceInfo',
  UPDATE_SOURCE_INFO: '/SourceInfo',
  // POST /AirlineRefreshConfiguration/Config — the real update path for
  // enabling/disabling + refreshing an airline's source config (confirmed
  // via live swagger.json). This is what SourceInfo's Edit/Save now calls.
  UPDATE_AIRLINE_CONFIGURATION: '/AirlineRefreshConfiguration/Config',
  // GET /ApiMetadata/names and /ApiMetadata/calls — backed by the api_name /
  // api_call SQL Server tables, feeding the Logs Insights API Name/API Call
  // dropdowns.
  GET_API_NAMES: '/ApiMetadata/names',
  GET_API_CALLS: '/ApiMetadata/calls',
};
